import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

export function AdminLayout() {
  const user = useAuthStore((s) => s.user)
  if (user?.role !== 'admin') return <Navigate to='/' replace />
  return <Outlet />
}
